import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import schema from './jsonSchemaDayClass';
import { Card, Form } from 'react-bootstrap';
import useFormGenerator from 'components/app/common/FormUtils';
import { useState } from 'react';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import useButtonsGenerator from 'components/app/common/functions/useButtonsGenerator';
import { use } from 'react';
const jsonSchema = schema;

const AddDayModal = ({ show, onHide, days, identifier, callback }) => {
  const [data, setData] = useState();
  const handleFormSubmit = (data) => {
    const updatedData = {
      ...data,
      dayOfWeek: data.dayOfWeek.value
    }
    console.log('Updated Data', updatedData);
    callback(updatedData);

    console.log('Data', updatedData);
    onHide(false);
  }
  const buttonsConf = [
    {
      name: 'Save Day',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Day');
      }
    }
  ];

  useEffect(() => {
    if (undefined !== identifier) {
      // Fetch the day data using the identifier and set it to state
      // For example:
      // DayService.retrieveDay(identifier)
      //   .then(data => setData(data))
      //   .catch(error => console.log(error));
      console.log('Fetching data for day with identifier:', identifier);
    }
  }, [identifier]);
  return (
    <Modal show={show} onHide={onHide} centered size="lg" days={days} identifier={identifier}>
      <Modal.Header closeButton>
        <Modal.Title>Add day</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {data || undefined === identifier ? (
          // Pass data to the form generator hook
          <FormGeneratorWithData data={data} buttonsConf={buttonsConf} onSubmit={handleFormSubmit} />
        ) : (
          <p>Loading...</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button variant="secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {

  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    jsonSchema,
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default AddDayModal;